<div [hidden]="!isLoading" class="text-xs-center">
  <i class="fas fa-spinner fa-spin"></i> <span>{{ message }}</span>
</div>
